import React from "react";
import '../style.css';
import { FormattedMessage } from 'react-intl';

function TodoList(props) {
    return (
        <section className="task-list current">
        <h2><FormattedMessage id="tasklist.h2" defaultMessage="Do it now!"/></h2>
        <ul>
            {props.children}
        </ul>
        </section>
    );
}

export { TodoList };